<template>
    <div>
        <!--录入物流信息弹窗表单-->
        <el-dialog title="物流信息" :visible.sync="dialogVisible" center :before-close="handleCloseDialog" v-if="dialog_type == 1">
            <el-form :model="form" ref="form" :rules="logisticsForm_rule" label-width="120px">
                <el-form-item label="寄件方式：" prop="express_way">
                    <el-select v-model="form.express_way" placeholder="请选择寄件方式">
                        <el-option v-for="item in expressOptions" :key="item.value" :label="item.label"
                                    :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="快递单号：" prop="express_no">
                    <el-input v-model="form.express_no"></el-input>
                </el-form-item>
                <el-form-item label="发货状态：" prop="send_status">
                    <el-select v-model="form.send_status" placeholder="请选择">
                        <el-option v-for="item in send_status_arr" :key="item.value" :label="item.label"
                                    :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input v-if="form.send_status == 1" v-model="form.send_memo" placeholder="请输入原因或者备注" style="width:50%;"></el-input>
                </el-form-item>
                <el-form-item label="签收状态：" prop="express_status">
                    <el-select v-model="form.express_status" placeholder="请选择">
                        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
                                    :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCloseDialog">取 消</el-button>
                <el-button type="primary" @click="handleSubmit" :loading="loading">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="寄件内容" :visible.sync="dialogVisible" center :before-close="handleCloseDialog" v-else-if="dialog_type == 2">
            <el-form :model="form" ref="form" :rules="contentForm_rule" label-width="120px">
                <el-form-item label="寄件类型：" prop="goods_type">
                    <el-select v-model="form.goods_type" placeholder="请选择寄件类型" multiple clearable>
                        <el-option v-for="item in goodsType" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="寄出日期：" prop="send_at">
                    <el-date-picker
                    v-model="form.send_at"
                    type="date"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    placeholder="选择寄出日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="寄件人：">
                    {{$store.getters.name}}
                </el-form-item>
                <el-form-item label="送达方式：" prop="send_type">
                    <el-radio-group v-model="form.send_type">
                        <el-radio :label="1">快递</el-radio>
                        <el-radio :label="2">邮件（请备注邮箱）</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="form.send_type == 1"  label="寄件快递：" prop="send_way">
                    <el-select v-model="form.send_way" placeholder="请选择送达方式" multiple clearable>
                        <el-option label="德邦快递" value="1"></el-option>
                        <el-option label="中通快递" value="2"></el-option>
                        <el-option label="圆通快递" value="3"></el-option>
                        <el-option label="顺丰快递" value="4"></el-option>
                        <el-option label="韵达快递" value="5"></el-option>
                        <el-option label="邮政快递" value="6"></el-option>
                        <el-option label="其他" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="收货地址：" prop="express_id">
                    <OrderAddress :express_id="form.express_id" :order_id="form.order_id" @change="handleSelect" style="width:60%;" :key="order_address_key"></OrderAddress>
                    &nbsp;&nbsp;&nbsp;
                    <el-button size="mini" type="text" @click="dialogExpressTable">+新增地址</el-button>
                </el-form-item>
                <el-form-item label="寄件备注：" prop="express_content">
                    <el-input v-model="form.express_content" autocomplete="off" placeholder="其他需要寄件的可在此处备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCloseDialog">取 消</el-button>
                <el-button type="primary" @click="handleSubmit" :loading="loading">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="物流信息" :visible.sync="dialogVisible" center :before-close="handleCloseDialog" v-else-if="dialog_type == 3">
            <el-form :model="form" ref="form" label-width="120px">
                <el-form-item label="发货状态：" prop="send_status">
                    <el-select v-model="form.send_status" placeholder="请选择">
                        <el-option v-for="item in send_status_arr" :key="item.value" :label="item.label"
                                    :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input v-if="form.send_status == 1" v-model="form.send_memo" placeholder="请输入原因或者备注" style="width:50%;"></el-input>
                </el-form-item>
                <el-form-item label="签收状态：" prop="express_status">
                    <el-select v-model="form.express_status" placeholder="请选择">
                        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
                                    :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCloseDialog">取 消</el-button>
                <el-button type="primary" @click="handleStatusSubmit" :loading="loading">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 添加表单 -->
        <ExpressTable :expressForm='expressForm' v-if="dialogExpressVisible" @handleAddExpress='addExpress'></ExpressTable>
    </div>
</template>
<script>
import OrderService from "~/services/order";
import OrderExpressService from '~/services/OrderExpress';
import OrderAddress from "~/widgets/OrderAddress.vue";
import ExpressTable from "~/views/order/expressTable.vue";
export default {
    props:{
        params:{
            type: Object,
            required: true,
        },
        dialog_type:{
            type: Number,
            required: false,
            default: 1,
        },
    },
    components:{
        OrderAddress,
        ExpressTable
    },

    data() {
        return {
            dialogVisible: true,
            form: {
                id: 0,
                ids: [],
                order_id: '',
                express_way: '',//寄件方式
                express_no: '',//快递单号
                express_content: '',//寄件内容
                express_status: 0,//快递状态
                sender: this.$store.getters.name,//寄件人
                goods_type: [],
                send_at: '',
                send_type: '',
                send_way: [],
                send_status: 0,
                send_memo: '',
                express_id: '',
            },
            logisticsForm_rule: {
                express_way: [
                    {required: true, message: '请选择寄件方式', trigger: 'blur'},
                ],
                express_no: [
                    {required: true, message: '请填写快递单号', trigger: 'blur'},
                ],
                express_status: [
                    {required: true, message: '请填选签收状态', trigger: 'change'},
                ],
            },
            contentForm_rule: {
                goods_type: [
                    {required: true, message: '请填选寄件类型', trigger: 'change'},
                ],
                send_at: [
                    {required: true, message: '请填选寄出日期', trigger: 'change'},
                ],
                send_type: [
                    {required: true, message: '请填选送达方式', trigger: 'change'},
                ],
                send_way: [
                    {required: true, message: '请选择寄件快递', trigger: 'change'},
                ],
                express_id: [
                    {required: true, message: '请填写收货地址', trigger: 'change'},
                ],
            },
            loading: false,
            goodsType: [],
            expressOptions: [],
            statusOptions: [],
            send_status_arr: [],
            restaurants: [],
            timeout:  null,
            expressForm: {},
            dialogExpressVisible: false,
            order_address_key: 1,
        };
    },
    created() {
        this.goodsType = OrderService.goodsType();
        this.expressOptions = OrderService.options();
        this.statusOptions = OrderService.statusOptions();
        this.send_status_arr = OrderService.sendStatus();
        this.form = Object.assign(this.form, this.params);
    },

    methods:{
        handleStatusSubmit(){
            this.$confirm('确定要批量更新物流状态吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        OrderService.logisticsStatus(this.form).then(res => {
                            if (res.code == 0) {
                                this.$message({
                                    type: 'success',
                                    message: '操作成功!'
                                });
                                this.$emit("addChange", res.data);
                                this.handleCloseDialog();
                            }
                            this.loading = false;
                        }).catch(() => {
                            this.loading = false;
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }).catch(() => {
            });
        },

        //添加寄件内容
        handleSubmit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    if (this.form.id) {
                        OrderService.updateLogistics(this.form).then(res => {
                            if (res.code == 0) {
                                this.$message({
                                    type: 'success',
                                    message: '操作成功!'
                                });
                                this.$emit("updateChange", res.data);
                                this.handleCloseDialog();
                            }
                            this.loading = false;
                        }).catch(() => {
                            this.loading = false;
                        });
                    } else {
                        OrderService.addLogistics(this.form).then(res => {
                            if (res.code == 0) {
                                this.$message({
                                    type: 'success',
                                    message: '添加成功!'
                                });
                                this.$emit("addChange", res.data);
                                this.handleCloseDialog();
                            }
                            this.loading = false;
                        }).catch(() => {
                            this.loading = false;
                        });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },

        handleCloseDialog(){
            this.$refs['form'].resetFields();
            this.form = {
                id: 0,
                ids: [],
                order_id: '',
                express_way: '',//寄件方式
                express_no: '',//快递单号
                express_content: '',//寄件内容
                express_status: 0,//快递状态
                sender: this.$store.getters.name,//寄件人
                goods_type: [],
                send_at: '',
                send_type: '',
                send_way: [],
                send_status: 0,
                send_memo: '',
                express_id: '',
            };
            this.dialogVisible = false;
            this.$emit("close");
        },

        handleSelect(value) {
            this.form.express_id = value;
        },

        dialogExpressTable() {
            this.expressForm = {};
            this.dialogExpressVisible = true;
            return true;
        },

        addExpress(form) {
            if (form) {
                delete form.id;
                form.order_id = this.form.order_id;
                OrderExpressService.create(form).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message:'添加成功',
                            type:'success'
                        });
                        this.order_address_key ++;
                        this.dialogExpressVisible = false;
                        this.$emit("addExpress", res.data);
                    }
                }).catch(err => {
                    console.error(err)
                    this.dialogExpressVisible = false;
                });
            }else{
                this.dialogExpressVisible = false;
            }
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/views/order/dialog/LogisticsForm.vue